import { get } from '@webapp-next/lib/request/webapp/apiv2';
import getLoginUser from '@webapp-next/lib/facades/get-login-user';
import getClassicBootstrapPromise from '@webapp-next/global-libs/classic-bootstrap-promise';
import deputyApiV1 from '@webapp-next/lib/request/deputy';

const PREFERENCES_API_URL = '/api/management/v2/employee/';
const PREFERENCES_PREFIX = 'API_PREF_';

// File uses events and local storage
/* eslint-disable no-undef */

export async function getPreferences() {
  const dpBootstrapPromise = getClassicBootstrapPromise();
  // if user id does not exist return prevents throwing
  // 404 in once.deputy.com as user is not yet set
  if (typeof getLoginUser().Id === 'undefined') {
    return;
  }
  // Purge existing localstorage of preferences
  for (const key in localStorage) {
    if (key.substring(0, 9) == PREFERENCES_PREFIX) {
      localStorage.removeItem(key);
    }
  }
  // Get all API Preferences
  const { data } = await get(
    PREFERENCES_API_URL + getLoginUser().Id + '/preferences'
  );
  // Cache preferences into localstorage
  for (const d of data.data) {
    localStorage.setItem(d.key, d.value);
  }
  dpBootstrapPromise.resolve('PreferencesDone');
}

export async function getPreference(pref, defaultValue = {}) {
  try {
    const dpBootstrapPromise = getClassicBootstrapPromise();
    // Check for promise when in parent not iframe
    await dpBootstrapPromise.get('PreferencesDone');
    return (
      JSON.parse(localStorage.getItem(`${PREFERENCES_PREFIX}${pref}`)) ??
      defaultValue
    );
  } catch (e) {
    console.warn(e);

    // this is a fallback to parse the preferences
    return (
      JSON.parse(
        JSON.stringify(localStorage.getItem(`${PREFERENCES_PREFIX}${pref}`))
      ) ?? defaultValue
    );
  }
}

/**
 * @param {Object} syncBackend Determines if a backend call should be sent when updating preference
 */

export function updatePreference(pref, value, { syncBackend } = {}) {
  // After updating preference in settings.js
  // we update the cache so we dont have to
  // make BE call again
  if (syncBackend) {
    deputyApiV1.post({ url: `/my/pref/${pref}`, body: value });
  }
  localStorage.setItem(PREFERENCES_PREFIX + '' + pref, JSON.stringify(value));
}

export default {
  getPreferences,
  getPreference,
  updatePreference,
};
